import React, { useState } from "react";
import classNames from "@node_modules/classnames";
import { InputFieldProps } from "@interfaces/uiElementTypes";

const InputField: React.FC<InputFieldProps> = ({
  id,
  name,
  type,
  accept,
  required = false,
  value = "",
  maxLength,
  onChange,
  label,
  className = "",
  placeholder = "",
  classNameCont = "",
  readOnly = false,
  inputRef = null,
  minNumber,
  maxNumber,
  onInvalidMessage = "შეავსეთ ველი",
  leftIcon,
  classNameIcon,
  prefix,
  pattern,
  disabled,
}) => {
  const [dynamicPlaceholder, setDynamicPlaceholder] = useState(placeholder);

  const handleFocus = () => {
    if (name === "verificationCode") {
      setDynamicPlaceholder("");
    }
  };

  const handleBlur = () => {
    if (name === "verificationCode" && value.trim() === "") {
      setDynamicPlaceholder("");
    }
  };

  const handleInvalid = (e: React.InvalidEvent<HTMLInputElement>) => {
    e.target.setCustomValidity(onInvalidMessage);
  };

  const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
    e.currentTarget.setCustomValidity("");
  };

  return (
    <div
      className={`relative flex w-full items-center justify-center ${classNameCont}`}
    >
      {leftIcon && (
        <span
          className={`nav_button absolute left-4 flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full ${classNameIcon}`}
        >
          {leftIcon}
        </span>
      )}

      <input
        disabled={disabled}
        id={id}
        name={name}
        maxLength={name === "verificationCode" ? maxLength : undefined}
        max={maxNumber}
        min={minNumber}
        type={type}
        required={required}
        value={type === "file" ? undefined : value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onInvalid={handleInvalid}
        onInput={handleInput}
        placeholder={label ? "" : dynamicPlaceholder}
        className={classNames(
          "text-black",
          "!pb-2 !pt-6",
          {
            "!pl-[72px]": prefix,
            "!pl-16": leftIcon,
            "pl-4": !prefix && !leftIcon,
            "input-field pt-6": label,
            "cursor-not-allowed opacity-50": disabled,
          },
          className,
        )}
        accept={accept}
        readOnly={readOnly}
        ref={inputRef}
        inputMode={type === "number" ? "numeric" : undefined}
        pattern={pattern || (type === "number" ? "[0-9]*" : undefined)}
      />
      <label
        className={classNames("input-label text-gray-400", {
          "!left-[72px]": prefix,
          "!left-16": leftIcon,
          "!left-6": !prefix && !leftIcon,
        })}
        htmlFor={id}
      >
        {label}
      </label>
      {prefix && <span className="input-prefix">{prefix}</span>}
    </div>
  );
};

export default InputField;
